import type { Salarie } from '@shared/types/Salarie';

export function createSalarieFixtureForAgent(): Salarie {
  return {
    id: 'sal_agent_fixture',
    tenant_id: 'tenant_agent',
    matricule: 'AGT001',
    nom: 'TEST',
    prenom: 'Cadre',
    date_naissance: '1990-01-01',
    nationalite: 'Gabonaise',
    sexe: 'M',
    poste: 'Test',
    categorie: 'Cadre',
    statut_contrat: 'CDI',
    statut: 'actif',
    date_embauche: '2025-01-01',
    salaire_base: 500_000,
    situation: 'celibataire',
    enfants: 0,
    cree_le: new Date().toISOString(),
  };
}
